/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import { HiddenJobMessage } from "../Utils";

export function InfoJobMessage() {

  return (
    <div id="messageJob" className="max-h-32 job-yellow rounded-lg py-2 px-3 mb-2 mt-2 text-base inline-flex items-center w-full border-2 hidden relative" role="alert">
      <div id="textJob" className="max-h-32 overflow-auto w-full text-wrap break-words whitespace-pre">
        A simple job information - check it out!
      </div>
      <button 
        aria-label="close-job-message" 
        id="buttonJob" 
        type="button" 
        className=" bg-red-500 opacity-80 text-white py-1 px-3 rounded-sm text-sm absolute bottom-2 right-2"
        onClick={HiddenJobMessage}
      >
        Close
      </button>
    </div>
  );
}